import { FolderGridItemObject, PersonGridItemObject, ServiceGridItemObject } from '@it2go/types';
import { createAction, props } from '@ngrx/store';

export const
    setPerson = createAction('[Person] setPerson', props<{ person: PersonGridItemObject }>()),
    setFolder = createAction('[Person] setFolder', props<{ folder: FolderGridItemObject }>());

export const
    setServices = createAction('[Person] setServices', props<{ services: ServiceGridItemObject[] }>()),
    setServicesPublic = createAction('[Person] setServicesPublic', props<{
        servicesPublic: ServiceGridItemObject[]
    }>()),
    setCurrentServiceId = createAction('[Person] setCurrentServiceId', props<{ serviceId: number }>());
